PayModalService = ($window, $location, AuthService, returnUrl) ->
  navigateToPayment: ->
    url = encodeURIComponent("/")
    paymentUrl = "/payment/new?return_url=#{url}&start_url=#{url}"

    if AuthService.isSignedIn()
      $window.location = paymentUrl
    else
      returnUrl.url = paymentUrl
      returnUrl.external = true
      $location.path '/session/new'

PayModalService.$inject = [
  "$window"
  "$location"
  "AuthService"
  "returnUrl"
]

module.exports = PayModalService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/pay-modal/pay-modal-service.coffee